import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles(() => ({
  divider: {
    backgroundColor: '#ffffff14',
  },
}));

function CustomDivider() {
  const classes = useStyles();
  return <Divider classes={{ root: classes.divider }} light />;
}

export default CustomDivider;
